import axios from 'axios';

const BASE = '/image-types';

export async function listImageTypes({ includeHidden = false } = {}) {
  const res = await axios.get(BASE, { params: includeHidden ? { include_hidden: 1 } : {} });
  return Array.isArray(res.data) ? res.data : [];
}

export async function createImageType(payload) {
  const res = await axios.post(BASE, payload);
  return res.data;
}

export async function updateImageType(key, payload) {
  const res = await axios.put(`${BASE}/${encodeURIComponent(key)}`, payload);
  return res.data;
}

export async function deleteImageType(key) {
  await axios.delete(`${BASE}/${encodeURIComponent(key)}`);
}

export async function hideImageType(key) {
  await axios.post(`${BASE}/${encodeURIComponent(key)}/hide`);
}

export async function restoreImageType(key) {
  await axios.post(`${BASE}/${encodeURIComponent(key)}/restore`);
}

// "Example image" upload from the image type modal. Returns a durable /share URL.
// (POR-14042)
export async function uploadImageTypePreview(file) {
  const form = new FormData();
  form.append('image', file);
  const res = await axios.post(`${BASE}/preview-image`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data?.url || '';
}

// "Example image" paste-a-URL from the image type modal. Server re-hosts the image through
// /share?file=... (SSRF-guarded) so it's always same-origin/CSP-safe. Returns a durable /share
// URL.
export async function resolveImageTypePreviewUrl(url) {
  const res = await axios.post(`${BASE}/preview-image-url`, { url });
  return res.data?.url || '';
}
